export default __webpack_public_path__ + "static/media/logo.ae162c56.png";